import { deserialize } from 'cerialize'
import moment from 'moment'
import { DATE_AND_TIME_FORMAT_REVERSE } from 'Constants/Global'

export class ReserveAccountsLog {
	@deserialize public id: number
	@deserialize public created_at: string
	@deserialize public user_partner_inn: string
	@deserialize public reserve_account_order_inn: string
	@deserialize public method: string
	@deserialize public response_code: boolean
	@deserialize public status_code: string
	@deserialize public reserve_account_order_number: string
	@deserialize public response_body: {
		resultCode: number
		statusList: {
			statusCode: number
			statusDesc: string
		}[]
		response?: {
			identificationULReserveRs?: {
				requestId?: string
				existRkoAccounts?: boolean
			}
		}
	}

	@deserialize public request_body: unknown
	@deserialize public rquid: string
	public get time_formatted(): string | undefined {
		return moment(this?.created_at).format(DATE_AND_TIME_FORMAT_REVERSE)
	}
}
